export default __webpack_public_path__ + "static/media/pink3.c92cb593.jpg";